import { Component, OnInit, Input } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { UserSelectionsService } from '../../services/user-selections/user-selections.service';
import { Router } from '@angular/router';
import { OptionCardReschedule } from '../../types/strings.type';
import { StringsService } from '../../services/strings/strings.service';
import { ErrorService } from '../../services/errors/error.service';

@Component({
    selector: 'rttd-option-card-reschedule',
    templateUrl: './option-card-reschedule.component.html',
    styles: [
        require('./option-card-reschedule.component.scss').default.toString(),
        require(`./option-card-reschedule.component.${environment.brand}.scss`).default.toString()
    ]
})
export class OptionCardRescheduleComponent implements OnInit {
    content: OptionCardReschedule;

    @Input() step: number;
    timezone = environment.timezone;
    @Input() bookingStartTime: Date;
    @Input() title: string;

    constructor(
        public userSelectionsService: UserSelectionsService,
        private router: Router,
        private stringsService: StringsService,
        private errorService: ErrorService) {
    }

    ngOnInit() {
        this.stringsService.get().subscribe((data: OptionCardReschedule) => {
            this.content = data['OptionCardReschedule'];
            if (!this.title) {
                this.title = data.title;
            }
        });
    }
}

